import { Injectable } from '@angular/core';
import { ForgotPasswordDto, ForgotPasswordResponse, LoginDto, LoginResponse, RegisterDto, RegisterResponse, ResetPasswordDto, ResetPasswordResponse, ValidateTokenDto, ValidateTokenResponse, VerifyEmailDto, VerifyEmailResponse } from '../dto/authentication.dto';
import { Factory } from '../factories/factory';

@Injectable({ providedIn: 'root' })
export class AuthenticationFactory extends Factory {
    
    protected override url: string = 'authentication';

    constructor() {
        super();
    }

    public validateToken(dto: ValidateTokenDto): Promise<ValidateTokenResponse> {
        return this.get(`validate-token`, dto);
    }

    public register(dto: RegisterDto): Promise<RegisterResponse> {
        return this.post('register', dto);
    }

    public login(dto: LoginDto): Promise<LoginResponse> {
        return this.post('login', dto);
    }

    public verifyEmail(dto: VerifyEmailDto): Promise<VerifyEmailResponse> {
        return this.post('verify-email', dto);
    }

    public forgotPassword(dto: ForgotPasswordDto): Promise<ForgotPasswordResponse> {
        return this.post(`forgot-password`, dto);
    }

    public resetPassword(dto: ResetPasswordDto): Promise<ResetPasswordResponse> {
        return this.post(`reset-password`, dto);
    }

    public changePassword(dto: { password: string }): Promise<{ done: true }> {
        return this.post('change-password', dto);
    }

    public logout(): Promise<void> {
        return this.delete('logout');
    }

}
